const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m295 32h-17v-17c0-8.284-6.716-15-15-15s-15 6.716-15 15v17h-32v-17c0-8.284-6.716-15-15-15s-15 6.716-15 15v17h-32v-17c0-8.284-6.716-15-15-15s-15 6.716-15 15v17h-32v-17c0-8.284-6.716-15-15-15s-15 6.716-15 15v17h-17c-24.813 0-45 20.187-45 45v390c0 24.813 20.187 45 45 45h250c24.813 0 45-20.187 45-45v-390c0-24.813-20.187-45-45-45zm-250 30h17v5c0 8.284 6.716 15 15 15s15-6.716 15-15v-5h32v5c0 8.284 6.716 15 15 15s15-6.716 15-15v-5h32v5c0 8.284 6.716 15 15 15s15-6.716 15-15v-5h32v5c0 8.284 6.716 15 15 15s15-6.716 15-15v-5h17c8.271 0 15 6.729 15 15v35h-280v-35c0-8.271 6.729-15 15-15zm250 420h-250c-8.271 0-15-6.729-15-15v-325h280v325c0 8.271-6.729 15-15 15z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m497 112c-8.284 0-15 6.716-15 15v5h-20v-45c0-24.813-20.187-45-45-45s-45 20.187-45 45v317.574c0 29.227 10.61 56.82 30 78.392v14.034c0 8.284 6.716 15 15 15s15-6.716 15-15v-14.034c19.39-21.572 30-49.165 30-78.392v-132.574h20v35c0 8.284 6.716 15 15 15s15-6.716 15-15v-180c0-8.284-6.716-15-15-15zm-80 341.586c-8.383-12.333-13.424-26.571-14.68-41.586h29.359c-1.255 15.015-6.296 29.254-14.679 41.586zm-15-71.586v-250h30v250zm0-295c0-8.271 6.729-15 15-15s15 6.729 15 15v15h-30zm60 155v-80h20v80z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265 237h-190c-8.284 0-15 6.716-15 15s6.716 15 15 15h190c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265 177h-190c-8.284 0-15 6.716-15 15s6.716 15 15 15h190c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265 297h-190c-8.284 0-15 6.716-15 15s6.716 15 15 15h190c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265 357h-190c-8.284 0-15 6.716-15 15s6.716 15 15 15h190c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m230 417h-155c-8.284 0-15 6.716-15 15s6.716 15 15 15h155c8.284 0 15-6.716 15-15s-6.716-15-15-15z",
    fill: "#ffffff",
    "data-original": "#000000",
    style: {},
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiary);
export default __webpack_public_path__ + "static/media/diary.720c648f6c206fa390778e9d9451402a.svg";
export { ForwardRef as ReactComponent };